// extracted by mini-css-extract-plugin
module.exports = {"btnTextStyle":"ImageUpload_btnTextStyle_28jMz"};